import { getCategoryList, addNewCategory } from '@/api/articleManage'

import { CATEGORY_TYPE } from '@/utils/enum'
export default {
  data() {
    return {
      categoryList: [],
      timer: null,
      time: 100
    }
  },
  created() {},
  methods: {
    handleGetCategoryList(type = CATEGORY_TYPE.ARTICLE, hasRoot = true) {
      getCategoryList({ type }).then(response => {
        let categoryList = response.data.content.itemArr
        categoryList = categoryList.map(item => {
          item.deep = 1
          if (item.children) {
            item.children.map(subItem => {
              subItem.deep = 2
              return subItem
            })
          }
          return item
        })
        this.categoryList = categoryList
        if (hasRoot) {
          this.handleAddCategoryRoot()
        }
      })
    },
    handleAddCategoryRoot() {
      const categoryList = [
        {
          id: 0,
          parentId: null,
          name: '全部分类',
          deep: 0,
          children: this.categoryList
        }
      ]
      this.categoryList = categoryList
    },
    handleTimeRereshCategory(type) {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // 后端数据延时
        this.handleGetCategoryList(type, true)
        this.timer && clearTimeout(this.timer)
      }, this.time)
    },
    handleAddSubNewCategory(item, type) {
      this.$prompt(
        `<span><i class="red-font">*</i>${this.$t('articleManage.categoryName')}</span>`,
        this.$t('articleManage.addSubNewClass'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          dangerouslyUseHTMLString: true,
          customClass: 'sky-hc-input-dialog',
          closeOnClickModal: false
        }
      ).then(({ value }) => {
        addNewCategory({
          name: value,
          parentId: item.id,
          type: type
        }).then(() => {
          this.handleTimeRereshCategory(type)
        })
      })
    }
  }
}
